import { createSelector } from 'reselect';

export const getDeferredServices = state => state.deferred;

export const getDeferredServicesIds = createSelector(
  getDeferredServices,
  deferredServices => deferredServices.map(service => service.id)
);



// WEBPACK FOOTER //
// ./src/store/reducers/deferred/selectors.js